/*
  2019-01-09: We want to show slots in the "preview" form of the SRP card as follows
  Within width of the SRP selector
  (1) always show available time slots
  (2) only show not available time slots if they are not next to another unavailable slot

  (2) is to make sure we show some scarsity as social proof

  This applies only to the "preview" form of the SRP card. The expanded view (clicking on more)
  should present all the options, hence it won't use this compactor function
 */
export const compactor = (slots: any) => {
  const compacted = [];
  let skipNextSlot = false;
  for (let i = 0; i < slots.length; i++) {
    if (slots[i].availability <= 0) {
      if (!skipNextSlot) {
        compacted.push(slots[i]);
        skipNextSlot = true;
      }
    } else {
      compacted.push(slots[i]);
      skipNextSlot = false;
    }
  }

  return compacted;
};
